import React, { MouseEventHandler, useEffect, useState } from "react"
import { PopoverContent } from "../popover.tsx"
import { useGetFeaturesQuery } from "../../features/feature/service.ts"

interface CriteriaItem {
  code: string
  value: boolean
}

interface CriteriaFilterProps {
  selectedCriteria: CriteriaItem[]
  onCriteriaChange: (criteria: CriteriaItem[]) => void
}

export const CriteriaFilter: React.FC<CriteriaFilterProps> = ({ selectedCriteria, onCriteriaChange }) => {
  const [draftCriteria, setDraftCriteria] = useState<CriteriaItem[]>(selectedCriteria)
  const { data: allAvailableCriteria = [] } = useGetFeaturesQuery()

  useEffect(() => {
    setDraftCriteria(selectedCriteria)
  }, [selectedCriteria])

  const handleCheckboxChange = (code: string, value: boolean) => {
    setDraftCriteria(prev => {
      const existing = prev.find(item => item.code === code)
      if (existing) {
        if (existing.value === value) {
          // Unchecking the box
          return prev.filter(item => item.code !== code)
        } else {
          // Switching from Да to Нет or vice-versa
          return prev.map(item => (item.code === code ? { ...item, value } : item))
        }
      } else {
        // Checking a box for the first time
        return [...prev, { code, value }]
      }
    })
  }

  const handleApply: MouseEventHandler<HTMLButtonElement> = e => {
    e.currentTarget?.blur()

    onCriteriaChange(draftCriteria)
  }

  const handleClear: MouseEventHandler<HTMLButtonElement> = e => {
    e.currentTarget?.blur()
    setDraftCriteria([])
    onCriteriaChange([])
  }

  const activeCriteriaCount = selectedCriteria.length
  const buttonVariant = activeCriteriaCount > 0 ? "btn-primary" : ""

  return (
    <div className="dropdown dropdown-end">
      <div className="form-control flex flex-col">
        <label className="label">
          <span className="label-text">&nbsp;</span>
        </label>
        <button className={`btn ${buttonVariant} relative`}>
          Критерии
          {activeCriteriaCount > 0 && (
            <div className="badge badge-neutral absolute -top-2 -right-2">{activeCriteriaCount}</div>
          )}
        </button>
      </div>
      <PopoverContent className="w-100 p-4">
        <table className="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th className="text-center">Да</th>
              <th className="text-center">Нет</th>
            </tr>
          </thead>
          <tbody>
            {allAvailableCriteria.map(criteria => (
              <tr key={criteria.code}>
                <td>{criteria.title}</td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={draftCriteria.some(c => c.code === criteria.code && c.value)}
                    onChange={() => handleCheckboxChange(criteria.code, true)}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={draftCriteria.some(c => c.code === criteria.code && !c.value)}
                    onChange={() => handleCheckboxChange(criteria.code, false)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end gap-2 mt-4">
          <button className="btn btn-sm" onClick={handleClear}>
            Очистить
          </button>
          <button className="btn btn-sm btn-primary" onClick={handleApply}>
            Применить
          </button>
        </div>
      </PopoverContent>
    </div>
  )
}
